import { hasCapability, type User } from "../base";

export const loanRateSheet = {
  read: (user: User) => hasCapability(user, "loanRateSheet.read"),
  publish: (user: User) => hasCapability(user, "loanRateSheet.publish"),
};
